module.exports = __webpack_public_path__ + "scripts/icons.woff?0be94a07";


//////////////////
// WEBPACK FOOTER
// ./semantic/dist/themes/default/assets/fonts/icons.woff
// module id = 1487
// module chunks = 1